import _ from "lodash";
import { storage } from "../../firebase";

const state = {
  isFetching: false,
  file: null,
  error: null
};

const getters = {
  invoiceLogoFile: state => state.file
};

async function getDownloadUrlForUserLogo(tenantId) {
  return await storage
    .ref()
    .child(`invoiceLogos/${tenantId}`)
    .getDownloadURL();
}

const actions = {
  async updateInvoiceLogo({ dispatch, getters }, payload) {
    const tenantId = getters.tenantId;

    await storage
      .ref()
      .child(`invoiceLogos/${tenantId}`)
      .putString(payload, "data_url");

    const logoDownloadUrl = await getDownloadUrlForUserLogo(tenantId);
    let userSettings = { ...getters.userSettings };

    userSettings = _.set(
      userSettings,
      "company.logoDownloadUrl",
      logoDownloadUrl
    );

    dispatch("updateUserSettings", userSettings);
    dispatch("fetchInvoiceLogo");
  },
  async fetchInvoiceLogo({ commit, getters }) {
    const logoDownloadUrl = await getDownloadUrlForUserLogo(getters.tenantId);

    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";

    xhr.onload = () =>
      commit("setInvoiceLogoFile", new File([xhr.response], "invoice_logo"));

    xhr.open("GET", logoDownloadUrl);
    xhr.send();
  }
};

const mutations = {
  setInvoiceLogoFile(state, file) {
    state.file = file;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
